import { isEmptyNullOrUndefined } from "./validation.utils";
import { isNull } from "underscore";
import {
  DataTableContextFilters,
  DateFilter,
} from "../components/DataTable/DataTableContext/DataTableContextProvider";
import { FilterType } from "../components/DataTable/DataTableFilters/DataTableFilters";
import { FmpFilters } from "../constants/filtering.constants";
import { Paging } from "../models/pagination/Paging";
import moment from "moment";

const defaultFormatDate = (date: Date): string => {
  const stringDateFormat = "YYYY/MM/DD";

  return moment(date).format(stringDateFormat);
};

const startDateKey = "startDate";
const endDateKey = "endDate";

const enrichParamWithFilters = (
  filters: DataTableContextFilters[],
  param: URLSearchParams,
  formatDate: (date: Date, endOfDay?: boolean) => string = defaultFormatDate
): void => {
  filters?.forEach((f) => {
    if (isEmptyNullOrUndefined(f.value)) {
      return;
    }

    if (f.type === FilterType.QueryParam && !isEmptyNullOrUndefined(f.value)) {
      param.append(f.key, f.value as string);
    }

    if (f.type === FilterType.Multiselect && !isEmptyNullOrUndefined(f.value)) {
      (f.value as string[] | number[]).forEach((value: any) => {
        param.append(f.key, value as string);
      });
    }

    if (f.type === FilterType.Text && !isEmptyNullOrUndefined(f.value)) {
      param.append(f.key, f.value as string);
    }

    if (f.type === FilterType.Date && !isEmptyNullOrUndefined(f.value)) {
      const { startDate, endDate, customKeys } = f.value as DateFilter;

      if (isNull(startDate) || isNull(endDate)) {
        return;
      }

      param.append(
        customKeys && customKeys.startKey
          ? customKeys.startKey
          : startDateKey,
        formatDate(startDate!, false)
      );
      param.append(
        customKeys && customKeys.endKey ? customKeys.endKey : endDateKey,
        formatDate(endDate!, true)
      );
    }
  });
};

const buildQueryParam = (
  model: DataTableContextFilters[],
  pagination: Paging,
  formatDate: (date: Date, endOfDay?: boolean) => string = defaultFormatDate
): URLSearchParams => {
  const param: URLSearchParams = new URLSearchParams();

  param.append(FmpFilters.pageSize, pagination.pageSize.toString());
  param.append(FmpFilters.pageNumber, pagination.pageNumber.toString());

  enrichParamWithFilters(model, param, formatDate);

  return param;
};

export default {
  buildQueryParam,
};
